<!--
 * @Author: xing.huang
 * @Date: 2023-03-17 11:48:30
 * @LastEditTime: 2023-03-23 09:34:53
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\order\CompleteTask\index.vue
 * 
-->
<template>
  <div class="complete-task" style="width:100%;heigh:100%;">
    <el-card class="table_searchbar">
      <el-row :gutter="20">
        <el-col :span="5">
          <div class="" @keydown.enter="btnSearch()">
            <span class="title">工单号：</span>
            <el-input
              size="small"
              style="max-width:180px"
              clearable
              v-model="searchForm.productionBatchCode"
              @keyup.native="$event.target.value = $event.target.value.replace(/^\s+|\s+$/gm, '')"
              maxlength="32"
              placeholder="工单号"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="" @keydown.enter="btnSearch()">
            <span class="title">物料信息：</span>
            <el-select
              popper-class="width180"
              @visible-change="
                ev => {
                  if (!ev) {
                    remoteMethod('');
                  }
                }
              "
              :loading="loading"
              style="max-width: 200px"
              clearable
              :remote-method="query => remoteMethod(query)"
              v-model="searchForm.materialId"
              filterable
              placeholder="物料编码"
              remote
            >
              <el-option v-for="item in materialList" :key="item.materialId" :label="`${item.materialName}/${item.materialCode}`" :value="item.materialId"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="">
            <span class="title">机组：</span>
            <el-select size="small" style="max-width:180px;" clearable v-model="searchForm.fmId" placeholder="机组" filterable>
              <el-option v-for="item in workShopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <el-form class="search-form" :model="searchForm" ref="form" label-width="0" :inline="false" size="small">
            <el-form-item
              prop="partProcessRatio"
              :rules="[
                {
                  pattern: /^([1-9]|[1-9]\d|100)$/,
                  required: false,
                  message: '请输入1-100的数字',
                  trigger: 'blur'
                }
              ]"
            >
              <div class="">
                <span class="title">进度＞：</span>
                <el-input
                  size="small"
                  style="max-width:180px"
                  clearable
                  v-model="searchForm.partProcessRatio"
                  @keyup.native="$event.target.value = $event.target.value.replace(/^\s+|\s+$/gm, '')"
                  maxlength="32"
                  placeholder="进度"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-col>

        <el-col :span="4">
          <div style="text-align:right">
            <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
            <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="table-card">
      <div class="table_common_operbar">
        <el-row>
          <el-button type="primary" size="small" @click="filishTask" :disabled="selectList.length == 0">完工</el-button>
        </el-row>
      </div>
      <el-table :data="tableData" stripe style="width: 100%;" class="deviceTable" @selection-change="handleSelectionChange">
        <el-table-column width="80" type="selection"></el-table-column>
        <el-table-column prop="workshopName" label="机组" min-width="90" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderCode" label="订单号" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productionBatchCode" label="工单号" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialCode" label="物料编码" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialName" label="物料名称" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specification" label="规格" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialQualityName" label="材质" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column v-for="item in extendedFieldList" show-overflow-tooltip :key="item.propertyName" :prop="item.propertyName" :label="item.propertyName" min-width="100"></el-table-column>
        <el-table-column prop="splitCount" label="计划数量" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="reportCount" label="完工数量" min-width="80"></el-table-column>
        <el-table-column prop="partProcessRatio" label="进度" min-width="80"></el-table-column>
        <el-table-column label="操作" fixed="right" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="filishTask(scope.row, true)" size="small">完工</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page" v-if="tableData.length > 0">
        <div class="total_page">
          <span> 共{{ tableTotalPage }}条 </span>
        </div>
        <div style="margin-top:10px;text-align:right; margin-bottom: 20px;">
          <el-pagination
            background
            @size-change="sizeChange"
            layout=" sizes, prev, pager, next, jumper"
            :page-count="tableTotalPage"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size.sync="pageSize"
            :total="tableTotalPage"
            @current-change="pageChange"
            :current-page.sync="tableCurrentPage"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "CompleteTask",
  data() {
    return {
      loading: false,
      selectList: [],
      materialList: [],
      workShopList: [],
      extendedFieldList: [],
      W: false,
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      searchFormTemp: "", //临时搜索数据
      searchForm: {
        materialId: null,
        productionBatchCode: "",
        fmId: null,
        partProcessRatio: null
      },
      searchCopy: {
        materialId: null,
        productionBatchCode: "",
        fmId: null,
        partProcessRatio: null
      },

      tableData: [],
      pageSize: 10,
      tableCurrentPage: 1,
      tableTotalPage: 2,
      data: {
        token: localStorage.getItem("token")
      },
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },

  mounted: function() {
    this.initTable();
    this.loadWorkShopList();
    this.getPropertyExtendList();
    this.remoteMethod();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
  },

  computed: {
    span() {
      return this.W ? 5 : 7;
    }
  },
  filters: {},

  methods: {
    async getPropertyExtendList() {
      let { code, data } = await this.$RequestUtil.getAsync({ url: "/api/property-extend/list", type: "sync", params: { type: 0 } });
      data.forEach(item => {
        item.propertyValue = null;
      });
      this.extendedFieldList = data;
    },

    handleSelectionChange(ev) {
      this.selectList = ev.map(item => item.splitId);
    },

    async filishTask(rowData, type) {
      let splitIdList = [];
      if (type) {
        splitIdList = [rowData.splitId];
      } else {
        splitIdList = commonUtils.cloneObj(this.selectList);
        if (splitIdList.length == 0) {
          this.$message.warning("请选择需要完完工工单");
          return;
        }
      }
      let { data, code, msg, message } = await this.$RequestUtil.postAsync({ url: "/api/productionTask/taskFinish", params: { splitIdList } });
      if (code == 0) {
        this.$message.success("完工成功!");
        this.search();
        if (type) {
          this.selectList = [];
        }
      } else {
        this.$message.error(msg || message);
      }
    },

    async loadWorkShopList() {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({ url: "/api/factoryModel/getWorkShopList", params: {} });
      if (code == 0) {
        this.workShopList = data;
      } else {
        this.$message.error(msg || message);
      }
    },

    async remoteMethod(webSearchStr) {
      this.loading = true;
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listMaterial", type: "sync", params: { webSearchStr } });
      this.materialList = data;
      this.loading = false;
    },

    sizeChange(ev) {
      this.pageSize = ev;
      this.search();
    },

    btnSearch: function() {
      this.tableCurrentPage = 1;
      this.btnPressType = 1;
      this.searchCopy = commonUtils.cloneObj(this.searchForm);
      this.search();
    },

    clearSearch() {
      let form = this.searchForm;
      this.btnPressType = 2;
      form.materialId = null;
      form.fmId = null;
      form.productionBatchCode = "";
      this.$refs["form"].resetFields();
      form.partProcessRatio = null;
      this.searchCopy = {
        materialId: null,
        fmId: null,
        productionBatchCode: "",
        partProcessRatio: null
      };
    },

    search: function() {
      this.$refs["form"].validate(valid => {
        if (!valid) {
          this.$message.warning("进度查询参数异常");
          return;
        }
        this.searchForm = commonUtils.cloneObj(this.searchCopy);
        let temp;
        switch (this.btnPressType) {
          case 1:
            temp = commonUtils.cloneObj(this.searchForm);
            this.searchFormTemp = commonUtils.cloneObj(temp);
            break;
          case 0:
            temp = {
              materialId: null,
              fmId: null,
              productionBatchCode: "",
              partProcessRatio: null
            };
            break;
          case 2:
            temp = this.searchFormTemp;
            break;
          case 3:
            temp = this.searchFormTemp;
            break;
        }
        this.$RequestUtil.post({
          url: "/api/productionTask/selectFinishPage",
          type: "sync",
          params: {
            pageNum: this.tableCurrentPage,
            pageSize: this.pageSize,
            materialId: temp.materialId,
            fmId: temp.fmId,
            productionBatchCode: temp.productionBatchCode,
            partProcessRatio: temp.partProcessRatio
          },
          success: res => {
            if (res.msg == this.$Global.RESPONSE.SUCCESS) {
              res.data.list.forEach(item => {
                for (let o in item.extendedFieldVOMap) {
                  item[`${o}`] = item.extendedFieldVOMap[o];
                }
              });

              this.tableData = res.data.list;
              this.tableTotalPage = res.data.total;

              if (res.data.total == 0 && this.fristLoad) {
                this.$message.warning("查询不到符合条件的数据");
              }
              this.fristLoad = true;
            } else {
              this.$message.error(res.message || res.msg);
            }
          }
        });
      });
    },

    pageChange: function(targetPage) {
      this.tableCurrentPage = targetPage;
      this.btnPressType = 3;
      this.search();
    },

    initTable: function() {
      this.search();
    }
  }
};
</script>

<style scoped>
.el-row {
  margin-bottom: 12px;

  & :last-child {
    margin-bottom: 0;
  }
}
.page {
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 1450px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}

.total_page {
  margin-top: 14px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
</style>

<style>
.complete-task .search-form .el-form-item__error {
  padding-left: 92px;
}
.width180 {
  width: 180px;
}
.complete-task .el-table__header-wrapper .el-checkbox__input {
  margin-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/CompleteTask/index.vue